"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedearpiercing = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 36 52",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedearpiercing` : '') + (description ? ` desc-brandedearpiercing` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedearpiercing"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedearpiercing"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.49 35.98c-2.65 7.96-13.3 3.5-10.41-3.36 1.88.04 3.7-.64 4.56-2.33 2.7-4.55-3.67-6.23-5-9.4-.93-7.12 2.81-14.47 10.84-14.67 8.65-.16 14.35 10.38 8.85 17.16-4.4 4.44-6.96 6.48-8.84 12.6Z",
    fill: "#F4BD96"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.23 23.67c-1.84 2.16-4.23 4.02-5.8 6.43 1.46-4.6 4.1-9.85 1.53-13.95a8.43 8.43 0 0 0-12.82-1.7 8.91 8.91 0 0 0-2.72 5.1c-.98-6.8 3.81-13.93 11.06-13.7 9.08-.33 14.47 11.06 8.75 17.82Z",
    fill: "#B66B40"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.83 13.95C33.59 5.68 25.93.35 18.07 0h-.1c-.18 0-.34-.02-.5 0A16.31 16.31 0 0 0 6.41 3.97C-1.97 10.47.54 21.67.2 30.87c.2 5.2-1.15 13.77 3.08 17.79a11.15 11.15 0 0 0 14.17 1.45l.32-.24c3.48-2.55 4.7-9.13 6.2-13.06.75-1.95 1.9-3.71 3.36-5.23 4.62-4.77 8.9-9.83 7.48-17.65v.02Zm-17.37 22C14.82 43.9 4.2 39.45 7.07 32.6c1.88.04 3.7-.64 4.55-2.34 2.7-4.54-3.65-6.21-4.98-9.39-.92-7.11 2.8-14.45 10.8-14.65 8.64-.16 14.33 10.37 8.84 17.14-4.39 4.44-6.94 6.48-8.82 12.6Z",
    fill: "#FFE1CB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11 42.53a3.48 3.48 0 0 0-3.23 2.16 3.5 3.5 0 1 0 6.73 1.33c0-.93-.37-1.81-1.02-2.47a3.52 3.52 0 0 0-2.47-1.02H11Z",
    fill: "#E90B5A"
  }));
};
var _default = exports.default = brandedearpiercing;